// @flow
import glamorous from 'glamorous'
import {
  colors,
  margin,
  padding,
  transition,
  typography,
  globalWithMediaQueries,
  breakpoint,
} from 'style'

globalWithMediaQueries('.post__image--half', {
  ...padding.left(3),
  ...padding.bottom(3),
  float: 'right',
  width: '50%',
  ...breakpoint.small({
    ...padding.left(0),
    width: '100%',
  }),
})

const Markdown = glamorous.div(
  {
    maxWidth: 700,
    ...padding.x(3),
    ...margin.x('auto'),
    '& p': {
      ...typography.body,
      ...margin.bottom(3),
    },
    '& a': {
      ...transition.fast('color'),
      color: colors.primary,
    },
    '& a:hover': {
      color: colors.primaryDark,
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      ...margin.bottom(2),
    },
    '& h1': {
      ...typography.title1,
    },
    '& h2': {
      ...typography.title2,
    },
    '& h3': {
      ...typography.title3,
    },
    '& h4, & h5, & h6': {
      ...typography.headline,
    },
  },
  ({ alignCenter = false }: { alignCenter?: boolean }) => ({
    textAlign: alignCenter ? 'center' : undefined,
  }),
)

export default Markdown



// WEBPACK FOOTER //
// ./src/components/atoms/Markdown.js